import { styled } from "@mui/material";
import InfoBottomSheet from "@shared/infoBottomSheet";
import { PAN_STATUS_VARIANTS } from "constants/panStatusVariants";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Container = styled("div")`
  padding-top: ${({ theme }) => theme.spacing(1)};
`;

function PanUnavailableNote() {
  const { t } = useTranslation();
  const panValidation = useSelector((state: any) => state.pan) as {
    panStatus: (typeof PAN_STATUS_VARIANTS)[keyof typeof PAN_STATUS_VARIANTS];
  };
  return (
    <Container>
      {(panValidation.panStatus ===
        PAN_STATUS_VARIANTS.PAN_UNAVAILABLE_CHECKED ||
        panValidation.panStatus ===
          PAN_STATUS_VARIANTS.PAN_UNAVAILABLE_UNCHECKED) && (
        <InfoBottomSheet
          mainMessage={t("pan_unavailable_main_message", {
            defaultValue:
              "A 20% TDS will be deducted from your payouts if you don’t provide a PAN.",
          })}
          title={t("twenty_percent_tax_question", {
            defaultValue: "Why is 20% TDS being deducted?",
          })}
          detailMessage={t("pan_unavailable_detail_message", {
            defaultValue:
              "If the PAN number not provided, as per India’s 194R tax guidelines, a 20% tax will be deducted",
          })}
        />
      )}
    </Container>
  );
}

export default PanUnavailableNote;
